import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MuiListItemIcon from '@mui/material/ListItemIcon';

import { units } from '../theme/units';

type ListItemIconProps = import('@mui/material/ListItemIcon').ListItemIconProps;

const useStyles = makeStyles()(() => ({
  extraSmallIcon: {
    minWidth: units.rem(0.5),
    fontSize: units.rem(0.5),
  },
  smallIcon: {
    minWidth: units.rem(2.5),
    fontSize: units.rem(1.25),
  },
}));

type IconSize = 'extraSmall' | 'small' | 'large';

interface Props {
  iconSize?: IconSize;
}

const ListItemIcon: React.FC<Props & ListItemIconProps> = ({
  iconSize = 'large',
  className,
  ...rest
}) => {
  const { classes, cx } = useStyles();

  const sizeClass = React.useMemo(() => {
    const sizes: Partial<Record<IconSize, string>> = {
      extraSmall: classes.extraSmallIcon,
      small: classes.smallIcon,
    };

    return sizes[iconSize];
  }, [classes.extraSmallIcon, classes.smallIcon, iconSize]);

  return <MuiListItemIcon {...rest} className={cx(className, sizeClass)} />;
};

export { ListItemIcon };
